<a
  [routerLink]="[panel.link]"
  [routerLinkActive]="'hover:bg-gray-100 dark:hover:bg-hover'"
  [routerLinkActiveOptions]="{ exact: true }"
  (click)="tabClicked.emit(panel)"
  >
  <div
    class="flex px-8 py-5 cursor-pointer"
    [routerLinkActive]="'bg-primary-50 dark:bg-hover'"
    >
    <mat-icon
      [routerLinkActive]="'text-primary dark:text-primary-500'"
      [svgIcon]="panel.icon"
    ></mat-icon>
    <div class="ml-3">
      <ng-container *transloco="let t">
        <div
          class="font-medium leading-6"
          [routerLinkActive]="'text-primary dark:text-primary-500'"
          >
          {{ panel?.ignoreTranslation ? panel.title : t(panel.title, panel?.titleParams) }}
        </div>
        @if (showDescription) {
          <div class="mt-0.5 text-secondary">
            {{
            panel?.ignoreTranslation ? panel.description : t(panel.description, panel?.descriptionParams)
            }}
          </div>
        }
      </ng-container>
    </div>
  </div>
</a>
